import React from "react";
import MaskedInput from "react-text-mask";
import "./../textField/textField.css";

export default class TimeTextField extends React.Component {
  state = { text: "" };

  changeValue = (value) => {
    this.setState({ text: value.target.value });
    this.props.parentCallback(value.target.value);
  };

  render() {
    return (
      <div
        style={{ display: this.props.hideInput ? "none" : "inline" }}
        className="Entrada"
      >
        <div>
          <label className="Label">
            <strong>{this.props.title}:</strong>
          </label>
        </div>
        <div>
          {this.props.seconds ? (
            <MaskedInput
              className="input"
              guide={false}
              autoFocus={this.props.autoFocus}
              mask={[/[0-2]/, /[0-9]/, ":", /[0-5]/, /\d/, ":", /\d/, /\d/]}
              value={this.props.value}
              name={this.props.name}
              id={this.props.id}
              autoComplete="off"
              placeholder={this.props.placeholder}
              disabled={this.props.disabled}
              onChange={this.changeValue}
            />
          ) : (
            <MaskedInput
              className="input"
              guide={false}
              autoFocus={this.props.autoFocus}
              autoComplete="off"
              mask={[/[0-2]/, /[0-9]/, ":", /[0-5]/, /[0-9]/]}
              value={this.props.value}
              name={this.props.name}
              id={this.props.id}
              disabled={this.props.disabled}
              onChange={this.changeValue}
            />
          )}
        </div>
      </div>
    );
  }
}